var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconFold18 = function SvgAIconFold18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "matrix(1 0 0 -1 0.00292969 18)",
    fill: "#00A3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0029 18H0.00292969L18.0029 0V18Z",
    fill: "#F0F9FD"
  })));
};
export { SvgAIconFold18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIj4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwLjAwMjkyOTY5IDE4KSIgZmlsbD0iIzAwQTNFMCIgLz4KPHBhdGggZD0iTTE4LjAwMjkgMThIMC4wMDI5Mjk2OUwxOC4wMDI5IDBWMThaIiBmaWxsPSIjRjBGOUZEIiAvPgo8L3N2Zz4K";